


const BookingDetails = () =>{

    return(
        <h1>booking</h1>
    )
}

export default BookingDetails;